var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mp-left-menu"}},[_c('div',{staticClass:"menus"},[_c('div',{staticClass:"menuTitle menuItemBorder"},[_vm._v(_vm._s(_vm.menus[0].menu[0].text))]),_vm._l((_vm.menus[1].menu),function(menu,index){return _c('div',{directives:[{name:"waves",rawName:"v-waves"}],key:index,class:_vm.menus[1].active === menu.id
          ? index + 1 === _vm.menus[1].menu.length
            ? 'menuItemActive'
            : 'menuItemActive menuItemBorder'
          : index + 1 === _vm.menus[1].menu.length
          ? 'menuItem'
          : 'menuItem menuItemBorder',on:{"click":function($event){_vm.menus[1].active = menu.id}}},[_vm._v(" "+_vm._s(menu.text)+" ")])})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }